import { b as _objectSpread2, u as useLanguagesQuery$1, j as useMenuQuery$1, c as _objectWithoutProperties, k as useNotificationQuery$1, l as _defineProperty, g as LanguageCodeEnum, T as TemplateEnum, m as usePageQuery$1, n as usePageByTemplateQuery$1, o as usePagesQuery$1, p as useArticleQuery$1, q as usePostsQuery$1, r as useCategoryQuery$1, s as useCategoriesQuery$1, t as useTagQuery$1, v as useTagsQuery$1, w as useLandingPageQuery$1 } from './__generated__-C2sSYBPz.js';
export { A as ArticleDocument, z as CategoriesDocument, C as CategoryDocument, E as LandingPageDocument, L as LanguagesDocument, M as MenuDocument, F as PageByTemplateDocument, P as PageDocument, x as PagesDocument, y as PostsDocument, B as TagDocument, D as TagsDocument } from './__generated__-C2sSYBPz.js';
import React__default, { createContext, useContext } from 'react';
import { u as useConfig, N as Navigation$1, l as Notification$1, m as Page$1, at as styleInject, M as MAIN_CONTENT_ID, n as PageContent$1 } from './archiveSearchPageContent.module-CtBGccQJ.js';
import 'isomorphic-dompurify';
import 'html-react-parser';
import { LoadingSpinner } from 'hds-react';
import 'date-fns';
import '@apollo/client';
import 'react-dom';

function useQueryWithApolloClientFromConfig() {
  var _useConfig = useConfig(),
    apolloClient = _useConfig.apolloClient;
  if (!apolloClient) {
    throw Error('When using components from the apollo sub module, you must include a compatible apollo client in the apolloClient field of the config object you provide with ConfigProvider');
  }
  return apolloClient;
}

function makeQueryWithApolloClientFromConfig(useQuery) {
  return function () {
    var baseOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var apolloClientFromConfig = useQueryWithApolloClientFromConfig();
    return useQuery(_objectSpread2({
      client: apolloClientFromConfig
    }, baseOptions));
  };
}

var useLanguagesQuery = makeQueryWithApolloClientFromConfig(useLanguagesQuery$1);

var useMenuQuery = makeQueryWithApolloClientFromConfig(useMenuQuery$1);

var _excluded$3 = ["menuName", "getPathnameForLanguage"];
function Navigation(_ref) {
  var _languagesQuery$data$, _languagesQuery$data, _menuQuery$data;
  var menuName = _ref.menuName,
    getPathnameForLanguage = _ref.getPathnameForLanguage,
    delegatedProps = _objectWithoutProperties(_ref, _excluded$3);
  var languagesQuery = useLanguagesQuery();
  var menuQuery = useMenuQuery({
    variables: {
      id: menuName
    }
  });
  var languages = (_languagesQuery$data$ = (_languagesQuery$data = languagesQuery.data) === null || _languagesQuery$data === void 0 || (_languagesQuery$data = _languagesQuery$data.languages) === null || _languagesQuery$data === void 0 ? void 0 : _languagesQuery$data.filter(function (l) {
    return !!l;
  })) !== null && _languagesQuery$data$ !== void 0 ? _languagesQuery$data$ : undefined;
  return /*#__PURE__*/React__default.createElement(Navigation$1, _objectSpread2(_objectSpread2({}, delegatedProps), {}, {
    languages: languages,
    menu: (_menuQuery$data = menuQuery.data) === null || _menuQuery$data === void 0 ? void 0 : _menuQuery$data.menu,
    getPathnameForLanguage: getPathnameForLanguage
  }));
}

var useNotificationQuery = makeQueryWithApolloClientFromConfig(useNotificationQuery$1);

var languageCodeEnumToNotificationLanguageMap = _defineProperty(_defineProperty(_defineProperty({}, LanguageCodeEnum.Fi, 'fi'), LanguageCodeEnum.Sv, 'sv'), LanguageCodeEnum.En, 'en');
function Notification(props) {
  var _useConfig = useConfig(),
    currentLanguageCode = _useConfig.currentLanguageCode;
  var _useNotificationQuery = useNotificationQuery({
      variables: {
        language: languageCodeEnumToNotificationLanguageMap[currentLanguageCode]
      }
    }),
    data = _useNotificationQuery.data;
  return /*#__PURE__*/React__default.createElement(Notification$1, _objectSpread2(_objectSpread2({}, props), {}, {
    notification: data === null || data === void 0 ? void 0 : data.notification
  }));
}

var apolloPageContext = /*#__PURE__*/createContext({});

var ApolloPageContextProvider = apolloPageContext.Provider;

var _excluded$2 = ["uri", "pageTemplate"];
function Page(_ref) {
  var _ref$uri = _ref.uri,
    uri = _ref$uri === void 0 ? '' : _ref$uri,
    _ref$pageTemplate = _ref.pageTemplate,
    pageTemplate = _ref$pageTemplate === void 0 ? TemplateEnum.FrontPage : _ref$pageTemplate,
    delegatedProps = _objectWithoutProperties(_ref, _excluded$2);
  var pageContextValue = React__default.useMemo(function () {
    return {
      uri: uri,
      pageTemplate: pageTemplate
    };
  }, [uri, pageTemplate]);
  return /*#__PURE__*/React__default.createElement(ApolloPageContextProvider, {
    value: pageContextValue
  }, /*#__PURE__*/React__default.createElement(Page$1, _objectSpread2({}, delegatedProps)));
}

var usePageQuery = makeQueryWithApolloClientFromConfig(usePageQuery$1);

var css_248z$1 = ".pageContent-module_loadingSpinnerContainer__B-SXR{align-items:center;display:flex;height:100%;justify-content:center;width:100%}";
var styles$1 = {"loadingSpinnerContainer":"pageContent-module_loadingSpinnerContainer__B-SXR"};
styleInject(css_248z$1);

function useApolloPageContext() {
  return useContext(apolloPageContext);
}

var _excluded$1 = ["notFoundPageContent"];
function PageContent(_ref) {
  var _pageQuery$data, _pageQuery$data2;
  var _ref$notFoundPageCont = _ref.notFoundPageContent,
    notFoundPageContent = _ref$notFoundPageCont === void 0 ? (/*#__PURE__*/React__default.createElement("div", null, "404 - Page not found. Provide the notFoundPageContent prop to PageContent to replace this message.")) : _ref$notFoundPageCont,
    delegatedProps = _objectWithoutProperties(_ref, _excluded$1);
  var _useApolloPageContext = useApolloPageContext(),
    uri = _useApolloPageContext.uri;
  var pageQuery = usePageQuery({
    variables: {
      id: uri
    }
  });
  if (pageQuery.loading) {
    return /*#__PURE__*/React__default.createElement("div", {
      id: MAIN_CONTENT_ID,
      className: styles$1.loadingSpinnerContainer
    }, /*#__PURE__*/React__default.createElement(LoadingSpinner, {
      multicolor: true
    }));
  }
  var pageNotFound = (pageQuery === null || pageQuery === void 0 || (_pageQuery$data = pageQuery.data) === null || _pageQuery$data === void 0 ? void 0 : _pageQuery$data.page) === null;
  if (pageNotFound) {
    return notFoundPageContent;
  }
  return /*#__PURE__*/React__default.createElement(PageContent$1, _objectSpread2(_objectSpread2({}, delegatedProps), {}, {
    page: pageQuery === null || pageQuery === void 0 || (_pageQuery$data2 = pageQuery.data) === null || _pageQuery$data2 === void 0 ? void 0 : _pageQuery$data2.page
  }));
}

var usePageByTemplateQuery = makeQueryWithApolloClientFromConfig(usePageByTemplateQuery$1);

var css_248z = ".pageWithTemplateContent-module_loadingSpinnerContainer__EJWBr{align-items:center;display:flex;height:100%;justify-content:center;width:100%}";
var styles = {"loadingSpinnerContainer":"pageWithTemplateContent-module_loadingSpinnerContainer__EJWBr"};
styleInject(css_248z);

var _excluded = ["language", "notFoundPageContent"];
function PageWithTemplateContent(_ref) {
  var _pageByTemplateQuery$, _pageByTemplateQuery$2;
  var language = _ref.language,
    _ref$notFoundPageCont = _ref.notFoundPageContent,
    notFoundPageContent = _ref$notFoundPageCont === void 0 ? (/*#__PURE__*/React__default.createElement("div", null, "404 - Page not found. Provide the notFoundPageContent prop to PageContent to replace this message.")) : _ref$notFoundPageCont,
    delegatedProps = _objectWithoutProperties(_ref, _excluded);
  var _useApolloPageContext = useApolloPageContext(),
    template = _useApolloPageContext.template;
  var pageByTemplateQuery = usePageByTemplateQuery({
    variables: {
      template: template,
      language: language
    }
  });
  if (pageByTemplateQuery.loading) {
    return /*#__PURE__*/React__default.createElement("div", {
      className: styles.loadingSpinnerContainer
    }, /*#__PURE__*/React__default.createElement(LoadingSpinner, {
      multicolor: true
    }));
  }
  var pageNotFound = (pageByTemplateQuery === null || pageByTemplateQuery === void 0 || (_pageByTemplateQuery$ = pageByTemplateQuery.data) === null || _pageByTemplateQuery$ === void 0 ? void 0 : _pageByTemplateQuery$.pageByTemplate) === null;
  if (pageNotFound) {
    return notFoundPageContent;
  }
  return /*#__PURE__*/React__default.createElement(PageContent$1, _objectSpread2(_objectSpread2({}, delegatedProps), {}, {
    page: pageByTemplateQuery === null || pageByTemplateQuery === void 0 || (_pageByTemplateQuery$2 = pageByTemplateQuery.data) === null || _pageByTemplateQuery$2 === void 0 ? void 0 : _pageByTemplateQuery$2.pageByTemplate
  }));
}

var usePagesQuery = makeQueryWithApolloClientFromConfig(usePagesQuery$1);

var useArticleQuery = makeQueryWithApolloClientFromConfig(useArticleQuery$1);

var usePostsQuery = makeQueryWithApolloClientFromConfig(usePostsQuery$1);

var useCategoryQuery = makeQueryWithApolloClientFromConfig(useCategoryQuery$1);

var useCategoriesQuery = makeQueryWithApolloClientFromConfig(useCategoriesQuery$1);

var useTagQuery = makeQueryWithApolloClientFromConfig(useTagQuery$1);

var useTagsQuery = makeQueryWithApolloClientFromConfig(useTagsQuery$1);

var useLandingPageQuery = makeQueryWithApolloClientFromConfig(useLandingPageQuery$1);

export { LanguageCodeEnum, Navigation, Notification, Page, PageContent, PageWithTemplateContent, useArticleQuery, useCategoriesQuery, useCategoryQuery, useLandingPageQuery, useLanguagesQuery, useMenuQuery, usePageByTemplateQuery, usePageQuery, usePagesQuery, usePostsQuery, useTagQuery, useTagsQuery };
